<template>
  <div class="flex justify-center pt-20">
    <button type="button" class="action-button mr-8" :disabled="isInFirstPage" @click="onClickPreviousPage">
      Anterior
    </button>

    <ul class="pages">
      <li>
        {{ value }}
      </li>

      <li v-if="!isInLastPage">
        <a href="#" @click.prevent="onClickLastPage">
          {{ totalPages }}
        </a>
      </li>
      <li v-else>
        {{ totalPages }}
      </li>
    </ul>

    <button type="button" class="action-button" :disabled="isInLastPage" @click="onClickNextPage">
      Próxima
    </button>
  </div>
</template>

<script>
export default {
  props: {
    perPage: {
      type: Number,
      default: 10
    },

    totalRows: {
      type: Number,
      required: true
    },

    value: {
      type: Number
    },
  },

  computed: {
    isInFirstPage() {
      return this.value === 1
    },

    isInLastPage() {
      return this.value === this.totalPages
    },

    totalPages() {
      return Math.ceil(this.totalRows / this.perPage)
    }
  },

  methods: {
    onClickPreviousPage() {
      this.$emit('input', this.value - 1)
    },

    onClickNextPage() {
      this.$emit('input', this.value + 1)
    },

    onClickLastPage() {
      this.$emit('input', this.totalPages)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~stylesheets/vars";

.pages {
  list-style: none;
  display: flex;
  @apply mr-8;

  li {
    color: $black;
    @apply p-2;
    @apply pl-0;
    @apply font-bold;

    a {
      color: $blue-light;

      &:hover {
        @apply transition;
        @apply ease-in-out;
        @apply duration-150;
        color: darken($blue-light, 25%);
        text-decoration: underline;
      }
    }
  }

  li+li:before {
    font-family: 'Arial';
    font-weight: 300;
    content: '\002F';
    color: $black;

    @apply pr-2;
  }
}

button.action-button {
  @apply text-base;
  @apply font-normal;
  color: $blue-light;

  &:disabled {
    color: $stroke-gray;
  }

  &:not(:disabled) {
    &:hover, &:focus, &:active {
      text-decoration: underline;
      @apply transition;
      @apply ease-in-out;
      @apply duration-150;
      color: darken($blue-light, 25%);
      outline: none;
    }
  }
}
</style>
